<template>
  <v-card>
    <v-card-title class="secondary white--text rounded-lg mb-2">
      <span
          :class="(filters['factor__type__in'] == 'sale' || filters['factor__type__in'] == 'buy')?'primary--text font-weight-bold':null"
          @click="filters['factor__type__in'] = type"
          style="cursor: pointer">
        {{title}}
      </span>
      <span class="mr-5 ml-5">
        |
      </span>
      <span
          style="cursor: pointer"
          @click="filters['factor__type__in'] = backFromType"
          :class="(filters['factor__type__in'] == 'backFromBuy' || filters['factor__type__in'] == 'backFromSale')?'primary--text font-weight-bold':null">
        گزارش برگشت از {{ layout.title }}
      </span>
      <span class="mr-5 ml-5" v-if="type == 'buy'">
        |
      </span>
      <span
          v-if="type == 'buy'"
          style="cursor: pointer"
          @click="filters['factor__type__in'] = 'fpi'"
          :class="(filters['factor__type__in'] == 'fpi')?'primary--text font-weight-bold':null">
        موجودی اول دوره
      </span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="wareLevels"
              v-model="filters.level"
              label="سطح کالا"
          />
          <v-select
              v-if="type != 'buy'"
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg mt-3"
              :items="wareTypes"
              v-model="filters.ware__is_service"
              label="نوع کالا"
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field class="rounded-lg" label="از کد کالا" type="number" v-model="filters.ware__code__gte"
                        clearable :disabled="filters.level == null"/>
          <v-text-field class="rounded-lg mt-3 " label="تا کد کالا" type="number" v-model="filters.ware__code__lte"
                        clearable :disabled="filters.level == null"/>
        </v-col>
        <v-col cols="12" md="2">
          <ware-select class="rounded-lg" label="انتخاب کالا" type="text" v-model="selected_ware"
                       :show-info="false" @change="setWareFilter()"
                       :multiple="true" :clearable="true" :show-main-unit="false"/>
        </v-col>
        <v-col cols="12" md="2">
          <div>
            <date label="از تاریخ" v-model="filters.factor__date__gte" :defualt="false" clearable/>
          </div>
          <div class="mt-3">
            <date label="تا تاریخ" v-model="filters.factor__date__lte" :defualt="false" clearable/>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field class="rounded-lg" label="از شماره فاکتور" type="number" v-model="filters.factor__code__gte"
                        clearable/>
          <v-text-field class="rounded-lg mt-3" label="تا شماره فاکتور" type="number"
                        v-model="filters.factor__code__lte" clearable/>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="waresStatuses"
              v-model="filters.status"
              label="وضعیت کالا"
          ></v-select>
        </v-col>

        <v-col cols="12">
          <template v-if="filters['factor__type__in'] != 'fpi'">
            <v-card class="rounded-lg secondary white--text text-center mt-1" v-if="type=='sale'">
              <v-row class="ma-1">
                <v-col cols="12" md="2" class="font-weight-bold primary--text">
                  کالا
                  <v-icon class="white--text mr-1">fa-angle-left</v-icon>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.goods.amount_sum | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>برگشت از {{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.goods.back_from | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>تخفیفات خالص : </span>
                  <span class="primary--text">{{ sums.goods.discount | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} خالص : </span>
                  <span class="primary--text">{{ sums.goods.amount | toMoney }} </span>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="rounded-lg secondary white--text text-center mt-1" v-if="type=='sale'">
              <v-row class="ma-1">
                <v-col cols="12" md="2" class="font-weight-bold primary--text">
                  خدمات
                  <v-icon class="white--text mr-1">fa-angle-left</v-icon>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.services.amount_sum | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>برگشت از {{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.services.back_from | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>تخفیفات خالص : </span>
                  <span class="primary--text">{{ sums.services.discount | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} خالص : </span>
                  <span class="primary--text">{{ sums.services.amount | toMoney }} </span>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="rounded-lg secondary white--text text-center mt-1 mb-3">
              <v-row class="ma-1">
                <v-col cols="12" md="2" class="font-weight-bold primary--text">
                  جمع کل
                  <v-icon class="white--text mr-1">fa-angle-left</v-icon>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.all.amount_sum | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>برگشت از {{ layout.title }} ناخالص : </span>
                  <span class="primary--text">{{ sums.all.back_from | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>تخفیفات خالص : </span>
                  <span class="primary--text">{{ sums.all.discount | toMoney }} </span>
                </v-col>
                <v-col cols="12" md="2">
                  <span>{{ layout.title }} خالص : </span>
                  <span class="primary--text">{{ sums.all.amount | toMoney }} </span>
                </v-col>
              </v-row>
            </v-card>
          </template>
          <m-datatable :headers="tableHeaders" :api-url="url" :filters.sync="filters" :show-select="false" ref="datatable">
            <template #item.factor.code="{ item }">
              <v-btn v-if="item.factor.code >= 0" text depressed color="info" icon rounded :to="goToFactor(item)"
              >{{ item.factor.code }}
              </v-btn>
              <v-btn v-else text depressed color="info" icon rounded @click="getToFpi(item)"
              >{{ item.factor.code }}
              </v-btn>
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";

export default {
  props: {
    wareId: {},
    type: {
      required: true,
    },
  },
  mixins: [wareApiMixin],
  data() {
    return {
      url: "reports/buySale",
      ware: null,
      sums: null,
      selected_ware: null,
      filters: {
        factor__type__in: "",
        ware: "",
        ware__name__icontains: "",
        level: null,
        ware__is_service: null,
        factor__is_defined: null,
      },
      layout: {
        title: "",
      },
    };
  },
  created() {
    this.getData();
    this.getSums();
  },
  methods: {
    getToFpi(item) {
      this.$router.push("/panel/factor/form/false/fpi/" + item.factor.id);
    },
    goToFactor(item) {
      let factor = item.factor;
      return {
        name: "FactorForm",
        params: {
          id: factor.id,
          type: factor.type,
          isPreFactor: factor.is_pre_factor,
        },
      };
    },
    setWareFilter() {
      let filter_wares_string = ''
      this.selected_ware.forEach(function (obj) {
        filter_wares_string += obj.id
        filter_wares_string += ','
      })
      filter_wares_string = filter_wares_string.slice(0, -1)
      this.filters.ware__id__in = filter_wares_string
      this.$refs.datatable.getDataFromApi()
    },
    getData() {
      Promise.all([this.getWares()]).then((data) => {
        this.init();
      });
    },
    getSums() {
      this.request({
        url: this.endpoint(`reports/buySaleSum?type=` + this.type),
        method: "get",
        success: (data) => {
          this.sums = data
        },
      });
    },

    init() {
      this.log("init list");
      this.setLayout();
      this.setDefaultFilters();

      if (this.wareId) {
        this.ware = this.wares.filter((o) => o.id == this.wareId)[0];
      }
    },
    setLayout() {
      if (this.type == "sale") this.layout.title = "فروش";
      else this.layout.title = "خرید";
    },
    setDefaultFilters() {
      if (this.type == "sale") {
        this.filters["factor__type__in"] = "sale";
      } else {
        this.filters["factor__type__in"] = "buy";
      }
    },
    selectWare() {
      this.filters.ware = this.ware.id;
    },
  },
  computed: {
    tableHeaders() {
      let result = [];
      if (this.filters.level == 0) {
        result.push(
            {
              text: "کد",
              value: "nature.code",
              sortable: false,
            },
            {
              text: "نام",
              value: "nature.name",
              sortable: false,
            },

        )
      }
      else if (this.filters.level == 1) {
        result.push(
            {
              text: "کد",
              value: "group.code",
              sortable: false,
            },
            {
              text: "نام",
              value: "group.name",
              sortable: false,
            },

        )
      }
      else if (this.filters.level == 2) {
        result.push(
            {
              text: "کد",
              value: "category.code",
              sortable: false,
            },
            {
              text: "نام",
              value: "category.name",
              sortable: false,
            },

        )
      }
      else {
        result.push(
            {
              text: "کد",
              value: "ware.code",
              sortable: false,
            },
            {
              text: "نام",
              value: "ware.name",
              sortable: false,
            },

        )
      }
      result.push(
          {
            text: "تاریخ",
            value: "factor.date",
            type: "date",
          },
          {
            text: "شماره فاکتور",
            value: "factor.code",
          },
          {
            text: "خریدار/فروشنده",
            value: "factor.account.name",
            type: "text",
          },
          {
            text: "انبار",
            value: "warehouse.name",
            type: "text",
          },
          {
            text: "تعداد",
            value: "count",
            type: "numeric",
            sortable: false,
          },
          {
            text: "فی",
            value: "fee",
            type: "numeric",
            sortable: false,
          },
          {
            text: "مبلغ",
            value: "value",
            type: "numeric",
            sortable: false,
          },
          {
            text: "تخفیف",
            value: "discountValue",
            type: "numeric",
            sortable: false,
          },
          {
            text: "مالیات",
            value: "tax_value",
            type: "numeric",
            sortable: false,
          },
          {
            text: "مبلغ کل",
            value: "total_value",
            type: "numeric",
            sortable: false,
          },
          {
            text: "شرح فاکتور",
            value: "factor.explanation",
            type: "text",
          },
          {
            text: "توضیحات",
            value: "explanation",
            type: "text",
          },
      )
      return result;

    },

    backFromType() {
      if (this.type == 'buy') {
        return 'backFromBuy'
      } else {
        return 'backFromSale'
      }
    },
    title(){
      if (this.type == 'buy') {
        return this.setDocumentTitle('گزارش خرید')
      } else {
        return this.setDocumentTitle('گزارش فروش')

      }
    }
  },
  watch: {
    form() {
      this.init();
    },
    type() {
      this.getData();
      this.getSums();
      this.init();
    },
    ware: {
      handler() {
        this.selectWare();
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss"></style>
